export default __webpack_public_path__ + "static/media/plane.34ede6cd.svg";